import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommentsService } from '../../../../core/services/comments.service';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'kt-cancel-task-dialog',
  templateUrl: './cancel-task-dialog.component.html',
  styleUrls: ['./cancel-task-dialog.component.scss'],
})
export class CancelTaskDialogComponent implements OnInit {
  viewLoading: boolean;
  formGroup: FormGroup;
  hasFormErrors: boolean;

  constructor(
    public dialogRef: MatDialogRef<CancelTaskDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commentsService: CommentsService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      reason: ['', Validators.required],
      confirmation: ['yes'],
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.formGroup.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.formGroup.controls;
    /** check form */
    if (this.formGroup.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    this.viewLoading = true;
    this.proceed(this.formGroup.controls.reason.value);
  }

  onNoClick() {
    this.close(false);
  }

  proceed(reason) {
    this.commentsService.postComment('tasks_v2', this.data.taskId, reason).subscribe(
      (res) => {
        if (res && res.data) {
          this.close(true);
        }
      },
      () => {
        const message = this.translate.instant('GLOBAL.UNSPECIFIED_ERROR');
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.close(false);
      },
    );
  }

  close(val) {
    this.dialogRef.close({
      cancelled: val,
    });
  }
}
